<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="attrForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Code</mat-label>
          <input matInput placeholder="" type="text" required formControlName="code" />
          <mat-hint *ngIf="data.edition" align="end">Si le code est modifié, un nouvel attribut sera créé</mat-hint>
          <mat-error>
            <span *ngIf="f('code').hasError('required')">Veuillez saisir un code</span>
            <span *ngIf="f('code').hasError('pattern')">Le code ne peut contenir que des majuscules, chiffres et
              '_'</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required placeholder="">
            <mat-option *ngFor="let categ of dictHelper.getAttributeTypes()" [value]="categ">
              {{ dictHelper.getAttributeTypeName(categ) }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Catégorie</mat-label>
          <mat-select formControlName="category" required placeholder="" (change)="updateGroupList()">
            <mat-option *ngFor="let categ of propHelper.getCategories()" [value]="categ">
              {{ propHelper.getCategoryName(categ) }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Groupe</mat-label>
          <mat-select formControlName="groupCode" required placeholder="">
            <mat-option *ngFor="let group of groupsByCategory[f('category').value]" [value]="group.code">{{
              group.display.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Types de bien autorisés</mat-label>
          <mat-hint align="end">Tous les types sont autorisés par défaut</mat-hint>
          <mat-select formControlName="allowedPropertyTypes" multiple>
            <mat-option *ngFor="let type of propHelper.getPropertyTypes()" [value]="type">{{
              propHelper.getTypeName(type)
              }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Unité</mat-label>
          <input matInput placeholder="" type="text" formControlName="unit" />
          <mat-error>
            <span *ngIf="f('unit').hasError('maxlength')">L'unité ne doit pas dépasser 15 caractères</span>
          </mat-error>
        </mat-form-field>
        <mat-slide-toggle class="col-md-3" formControlName="required" [checked]="this.f('required').value"
          color="primary">Obligatoire ?</mat-slide-toggle>
        <mat-slide-toggle class="col-md-3" formControlName="summary" [checked]="this.f('summary').value"
          color="primary">Visible dans le résumé ?</mat-slide-toggle>
        <mat-slide-toggle class="col-md-3" formControlName="inCertification" [checked]="this.f('inCertification').value"
          color="primary">Inclus dans la certif ?</mat-slide-toggle>
        <mat-slide-toggle class="col-md-3" formControlName="rescue" [checked]="this.f('rescue').value" color="primary">
          Accessible aux secours ?</mat-slide-toggle>
      </div>
      <div *ngIf="isTypeEnum()">
        <div class="row">
          <h4>Valeurs disponibles</h4>
          <a (click)="addAvailableValue()" matTooltip="Ajouter" class="ml-2">
            <mat-icon color="primary" aria-label="Ajouter">add_circle</mat-icon>
          </a>
        </div>
        <div formArrayName="availableValues" *ngFor="let valueForm of availableValues.controls; let i = index"
          class="form-group">
          <div [formGroupName]="i" class="d-flex flex-row">
            <mat-form-field class="col-md-6 col-lg-4">
              <mat-label>Code</mat-label>
              <input matInput placeholder="" type="text" required formControlName="code" />
              <mat-error>
                <span *ngIf="availableValues.controls[i].get('code').hasError('required')">Veuillez saisir un
                  code</span>
                <span *ngIf="availableValues.controls[i].get('code').hasError('pattern')">Le code ne peut contenir que
                  des majuscules, chiffres et '_'</span>
              </mat-error>
            </mat-form-field>
            <div formGroupName="display">
              <mat-form-field class="col-md-6 col-lg-4">
                <mat-label>Nom</mat-label>
                <input matInput placeholder="" type="text" required formControlName="name" />
                <mat-error>
                  <span *ngIf="availableValues.controls[i].get('display.name').hasError('required')">Veuillez saisir un
                    nom</span>
                  <span *ngIf="availableValues.controls[i].get('display.name').hasError('maxlength')">Le nom ne doit pas
                    dépasser 50 caractères</span>
                </mat-error>
              </mat-form-field>
              <mat-form-field class="col-md-6 col-lg-4">
                <mat-label>Description</mat-label>
                <input matInput placeholder="" formControlName="description" />
                <mat-error>
                  <span *ngIf="
                      availableValues.controls[i].get('display.description').hasError('maxlength')
                    ">La description ne doit pas dépasser 160 caractères</span>
                </mat-error>
              </mat-form-field>
              <mat-form-field class="col-md-6 col-lg-4">
                <mat-label>Ordre</mat-label>
                <input matInput placeholder="" type="text" formControlName="order" nullValue />
                <mat-error>
                  <span *ngIf="availableValues.controls[i].get('display.order').hasError('pattern')">L'ordre doit être
                    un nombre entier</span>
                </mat-error>
              </mat-form-field>
            </div>
            <a (click)="removeAvailableValue(i)" matTooltip="Supprimer">
              <mat-icon color="primary" aria-label="Supprimer">delete_forever</mat-icon>
            </a>
            <mat-divider></mat-divider>
          </div>
        </div>
      </div>
      <div class="row">
        <h4>Affichage</h4>
      </div>
      <div formGroupName="display" class="form-group row">
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Nom</mat-label>
          <input matInput placeholder="" type="text" required formControlName="name" />
          <mat-error>
            <span *ngIf="f('display.name').hasError('required')">Veuillez saisir un nom</span>
            <span *ngIf="f('display.name').hasError('maxlength')">Le nom ne doit pas dépasser 50 caractères</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Description</mat-label>
          <textarea matInput placeholder="" formControlName="description"></textarea>
          <mat-error>
            <span *ngIf="f('display.description').hasError('maxlength')">La description ne doit pas dépasser 160
              caractères</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6 col-lg-4">
          <mat-label>Ordre</mat-label>
          <input matInput placeholder="" type="text" formControlName="order" nullValue />
          <mat-error>
            <span *ngIf="f('display.order').hasError('pattern')">L'ordre doit être un nombre entier</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button mat-flat-button class="m-2" color="primary" matTooltip="Valider" type="submit"
          [disabled]="formSubmitting">
          Valider
        </button>
        <button mat-flat-button class="m-2" color="primary" mat-dialog-close matTooltip="Annuler" (click)="onNoClick()">
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>